import { useEffect, useState } from "react";
import { authenticatedUserAddress, getUserData } from "../../services/auth";
import MintOriginModal from "../../components/modal/MintOriginModal";
import { clientNetwork, devPrincipal } from "../../lib/constants";
import UpdateOriginModal from "../../components/modal/UpdateOriginModal";
import { getInterfaceInfo } from "../../services/chime";

const appOrigin = window.location.origin;

const ActivateInterface = () => {
  const [showActivateBtn, setShowActivateBtn] = useState(false);
  const [showUpdateBtn, setShowUpdateBtn] = useState(false);
  const [mintOriginModal, setMintOriginModal] = useState(false);
  const [updateOriginModal, setUpdateOriginModal] = useState(false);

  function openMintOriginModal() {
    setMintOriginModal(true);
  }

  function openUpdateOriginModal() {
    setUpdateOriginModal(true);
  }

  // Ensure that authUser retrieves the correct testnet address.
  const authUser = authenticatedUserAddress({ network: clientNetwork });

  // Debugging: Log authUser and devPrincipal
  console.log("Auth User:", authUser);
  console.log("Dev Principal:", devPrincipal);

  async function init() {
    // Check if authUser is properly defined before proceeding
    if (!authUser) {
      console.error("Auth User is not defined");
      return;
    }

    // Correct the condition check by explicitly comparing strings
    if (devPrincipal === authUser) {
      try {
        const { devPrincipal: devAddress } = await getInterfaceInfo();
        console.log("Fetched Dev Address:", devAddress);

        // Corrected condition for devAddress comparison
        if (devAddress === authUser) {
          setShowActivateBtn(false);
          setShowUpdateBtn(true);
        } else {
          setShowActivateBtn(true);
          setShowUpdateBtn(false);
        }
      } catch (error) {
        console.error("Error fetching interface info:", error);
        setShowActivateBtn(true);
        setShowUpdateBtn(false);
      }
    } else {
      setShowActivateBtn(false);
      setShowUpdateBtn(false);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    // Add debugging for button states
    console.log("Activate Button:", showActivateBtn);
    console.log("Update Button:", showUpdateBtn);
  }, [showActivateBtn, showUpdateBtn]);

  return (
    <>
      {showActivateBtn && (
        <button className={"settings-button"} onClick={openMintOriginModal}>
          Activate Origin
        </button>
      )}
      {showUpdateBtn && (
        <button
          className={"settings-button"}
          onClick={openUpdateOriginModal}
          disabled={!showUpdateBtn}
        >
          Update Origin
        </button>
      )}
      {mintOriginModal && (
        <MintOriginModal
          show={mintOriginModal}
          close={() => setMintOriginModal(false)}
        />
      )}
      {updateOriginModal && (
        <UpdateOriginModal
          show={updateOriginModal}
          close={() => setUpdateOriginModal(false)}
        />
      )}
    </>
  );
};

export default ActivateInterface;
